// extracted by mini-css-extract-plugin
export default {"TextButton":"textButton_TextButton__ijciQ"};